/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { ActionButton, AssetActionButton } from 'types/components/ActionButtonsGroup';
import { Button } from '.';
import { ButtonType } from './Button';

interface Props {
  bemBlock: string;
  data: (ActionButton | AssetActionButton)[];
  className?: string;
  small?: boolean;
  onMouseOver?: (optionIndex: number) => void;
  onMouseLeave?: () => void;
}

export default function ActionButtonsGroup({
  bemBlock,
  data,
  className = '',
  small,
  onMouseOver,
  onMouseLeave,
}: Props): JSX.Element {
  return (
    <div id={`${bemBlock}_buttonsGroup`} className={`btn-group actions ${className}`}>
      {data.map((button, index) => (
        <Button
          key={button.key}
          bemBlock={bemBlock}
          bemModifier={button.key}
          className={`${small ? 'btn-small' : ''} ${button.className || ''}`}
          buttonType={button.linkPath ? ButtonType.LINK : ButtonType.BUTTON}
          linkPath={button.linkPath}
          text={(button as ActionButton).text || (button as AssetActionButton).title}
          progressPercentage={(button as ActionButton).progressPercentage || (button as AssetActionButton).progress}
          onClick={() => button.onClick && button.onClick(button.key)}
          onMouseOver={() => onMouseOver && onMouseOver(index)}
          onMouseLeave={onMouseLeave}
        />
      ))}
    </div>
  );
}
